import { Link, useNavigate } from "react-router-dom";
import Layout from "../include/layout";
import { myroutes } from "../../routes/webroute";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import PublicationsService from "../../services/PublicationsService";
import Swal from "sweetalert2";
import $ from "jquery"
import TypespublicationsService from "../../services/TypespublicationsService";
import EditeursService from "../../services/EditeursService";
import AuteursService from "../../services/AuteursService";
import CategoriesService from "../../services/CategoriesService";
import CollectionsService from "../../services/CollectionsService";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import MotsClesService from "../../services/MotsClesService";
import PeriodiquesService from "../../services/PeriodiquesService";
import { useSelector } from "react-redux";

export default function CreatePublications() {

    //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const navigate = useNavigate()
    const [validationError, setValidationError] = useState({})

    const token = useSelector(state => state.auth.token)
    const animatedComponents = makeAnimated();

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [typepublication_id, setTypePublication] = useState([])
    const [typespublications, setTypesPublications] = useState([])
    const [editeur_id, setEditeur] = useState([])
    const [liste_editeurs, setListeEditeurs] = useState([])
    const [auteur_id, setAuteur] = useState([])
    const [liste_auteurs, setListeAuteurs] = useState([])
    const [autre_auteur_id, setAutreAuteur] = useState([])
    const [titre_ouvrage, setTitreOuvrage] = useState('')
    const [prefacier, setPrefacier] = useState('')
    const [t_periodique, setTPeriodique] = useState('')
    const [titre_periodique, setTitrePeriodique] = useState('')
    const [sous_titre, setSousTitre] = useState('')
    const [categorie_id, setCategorie] = useState([])
    const [liste_categories, setListeCategories] = useState([])
    const [avant_propos, setAvantPropos] = useState([])
    const [mot_cle, setMotCle] = useState([])
    const [liste_mots_cles, setListeMotscles] = useState([])
    const [montant_publication_ouvrage, setMontantOuvrage] = useState('')
    const [montant_publication_periodique, setMontantPeriodique] = useState('')
    const [annee_publication, setAnneePublication] = useState("")
    const [collection_id, setCollection] = useState([])
    const [liste_collections, setListeCollections] = useState([])
    const [code_isbn, setCodeIsbn] = useState('')
    const [nbre_page, setNbrePage] = useState('')
    const [choix_pdf, setChoixPdf] = useState([])
    const [laune_path, setLaUne] = useState("")
    const [publication_path, setPublication] = useState()
    const [resume, setResume] = useState('')

    ///Save form data
    const handleSubmit = async (event) => {
        event.preventDefault()
        //Recupérer uniquement les id
        var motcle_id = mot_cle.map((option) => option.value)
        var categories = categorie_id.map((option) => option.value)
        var coauteur_id = autre_auteur_id.map((option) => option.value)
        let form = {
            resume, publication_path, laune_path, choix_pdf, nbre_page, code_isbn, collection_id, annee_publication,
            montant_publication_periodique, montant_publication_ouvrage, motcle_id, avant_propos, categories,
            sous_titre, titre_periodique, t_periodique, prefacier, titre_ouvrage, coauteur_id, auteur_id,
            editeur_id, typepublication_id,
        }

        await PublicationsService.store(form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                    showConfirmButton: false,
                    timer: 2000
                })
                setValidationError(response.data.erreur)
            } else {

                //redirection sur index
                navigate(myroutes.publications_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    //get liste des types de publications
    const fetchTypes = async () => {
        await TypespublicationsService.index(token).then((res) => {
            setTypesPublications(res.data.typepublications)
        }).catch(error => {
            console.log(error)
        })
    }

    //get listes editeurs
    const fetchEditeurs = async () => {
        await EditeursService.index().then((res) => {
            setListeEditeurs(res.data.liste_editeurs)
        }).catch(error => {
            console.log(error)
        })

    }

    //get liste auteurs
    const fetchAuteurs = async () => {
        await AuteursService.index().then((res) => {
            setListeAuteurs(res.data.liste_auteurs)
        }).catch(error => {
            console.log(error)
        })

    }

    const auteursOptions = liste_auteurs.map((auteur) => ({
        value: auteur.id,
        label: auteur.nom_auteur
    }));

    const handleAutreAuteurSelection = (selectedOption) => {
        setAutreAuteur(selectedOption)
    }

    //get liste categories
    const fetchCategories = async () => {
        await CategoriesService.index().then((res) => {
            setListeCategories(res.data.categories)
        }).catch(error => {
            console.log(error)
        })
    }

    const categoriesOptions = liste_categories.map((categorie) => ({
        value: categorie.id,
        label: categorie.libelle
    }));

    const handleCategorieSelection = (selectedOption) => {
        setCategorie(selectedOption)
    }

    //get liste collections
    const fetchCollections = async () => {
        await CollectionsService.index(token).then((res) => {
            setListeCollections(res.data.collections)
        }).catch(error => {
            console.log(error)
        })

    }

    //get liste mots cles
    const fetchMotsCles = async () => {
        await MotsClesService.index(token).then((res) => {
            setListeMotscles(res.data.motscles)
        }).catch(error => {
            console.log(error)
        })

    }

    const motsclesOptions = liste_mots_cles.map((mot_cle) => ({
        value: mot_cle.id,
        label: mot_cle.libelle
    }));

    const handleMotCleSelection = (selectedOption) => {
        setMotCle(selectedOption)
    }


    //if type publication change
    //Afficher les champs
    const typeChange = (event) => {
        var choix = event.target.value
        setTypePublication(event.target.value)
        if (choix !== "") {
            if (choix === "1") { // ouvrage selected

                $("#show_sous_titre").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#sous_titre").attr("required", false);
                // auteur obligatoire 
                $("#id_auteur").attr("required", true);
                $("#auteur_rq").text("*");

                $("#show_sous_collection").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#collection").attr("required", false);

                $("#show_sous_montant").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#montant_publication").attr("required", true);

                $("#show_titre_ouvrage").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#titre_ouvrage").attr("required", true);

                $("#show_sous_titre_periodique").addClass("visually-hidden");
                $("#titre_periodique").attr("required", false);
                $("#titre_periodique").val("");

                $("#show_sous_montant_periodique").addClass("visually-hidden");
                $("#montant_periodique").attr("required", false);
                $("#montant_periodique").val("");

                $("#show_titre_periodique").addClass("visually-hidden");
                $("#t_periodique").attr("required", false);
                $("#titre_periodique").attr("required", false);
                $("#titre_periodique").val("");

            } else if (choix === "2") {
                $("#show_sous_titre_periodique").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#titre_periodique").attr("required", true);
                // auteur non obligatoire 
                $("#id_auteur").attr("required", false);
                $("#auteur_rq").text("");

                $("#show_sous_montant_periodique").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#montant_periodique").attr("required", true);

                $("#show_titre_periodique").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#titre_periodique").attr("required", true);
                $("#t_periodique").attr("required", true);

                $("#show_sous_titre").addClass("visually-hidden");
                $("#sous_titre").attr("required", false);
                $("#sous_titre").val("");

                $("#show_sous_collection").addClass("visually-hidden");
                $("#collection").attr("required", false);
                $("#collection").val("");

                $("#show_sous_montant").addClass("visually-hidden");
                $("#montant_publication").attr("required", false);
                $("#montant_publication").val("");

                $("#show_titre_ouvrage").addClass("visually-hidden");
                $("#titre_ouvrage").attr("required", false);
                $("#titre_ouvrage").val("");

            } else {
                // si aucune valeur n'est sélectionné dans le champ type

                // auteur non obligatoire 
                $("#id_auteur").attr("required", false);
                $("#auteur_rq").text("");
            }
        } else {
            $("#show_sous_collection").addClass("visually-hidden");
            $("#collection").attr("required", false);
            $("#collection").val("");

            $("#show_sous_collection").addClass("visually-hidden");
            $("#collection").attr("required", false);
            $("#collection").val("");

            $("#show_sous_montant").addClass("visually-hidden");
            $("#montant_publication").attr("required", false);
            $("#montant_publication").val("");

            $("#show_sous_titre_periodique").addClass("visually-hidden");
            $("#titre_periodique").attr("required", false);
            $("#t_periodique").attr("required", false);
            $("#titre_periodique").val("");

            $("#show_sous_montant_periodique").addClass("visually-hidden");
            $("#montant_periodique").attr("required", false);
            $("#montant_periodique").val("");

            $("#show_titre_ouvrage").addClass("visually-hidden");
            $("#titre_ouvrage").attr("required", false);
            $("#titre_ouvrage").val("");

            $("#show_titre_periodique").addClass("visually-hidden");
            $("#titre_periodique").attr("required", false);
            $("#titre_periodique").val("");
        }
        //alert(choix)
    }

    //// afficher dynamiquement la publication en fonction du choix de la disponibilité du pdf
    const choixPdf = (event) => {
        var choix = event.target.value
        setChoixPdf(event.target.value)
        if (choix !== "") {
            if (choix === "1") {
                $("#show_publication").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#publication").attr("required", true);

            } else {
                $("#show_publication").addClass("visually-hidden");
                $("#publication").attr("required", false);
                $("#publication").val("");
            }
        } else {
            $("#show_publication").addClass("visually-hidden");
            $("#publication").attr("required", false);
            $("#publication").val("");
        }
    }

    //if editeur change
    const editeurChange = async (event) => {
        var editeur_id = event.target.value
        if (editeur_id !== "") {
            setEditeur(event.target.value)
            $('#t_periodique').empty();
            $('#montant_periodique').empty();
            $('#t_periodique').append(
                '<option value="" selected="selected">Choisir dans la liste</option>');
            $('#montant_periodique').append(
                '<option value="" selected="selected">Choisir dans la liste</option>');

            //get titre periodique
            let form = { "editeur_id": editeur_id }
            await PeriodiquesService.getTitrePeriodique(form,token).then((response) => {
                if (response.data.erreur) {
                    Swal.fire({
                        icon: "error",
                        text: response.data.erreur,
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setValidationError(response.data.erreur)
                } else {
                    //Remplir le select de t_periodique
                    for (let index = 0; index < response.data.titre_periodique.length; index++) {
                        const element = response.data.titre_periodique[index];

                        $('#t_periodique').append('<option value="' + element.id +
                            '">' + element.titre_periodicite + '</option>');

                    }
                }
            }).catch(error => {
                Swal.fire({
                    icon: "error",
                    text: error.message,
                    showConfirmButton: true,
                    timer: 2000
                })
                setValidationError(error.message)
            })
        }
    }

    //if t_periodique change
    const TperiodiqueChange = async (event) => {
        var titre_p = event.target.value
        setTPeriodique(event.target.value)

        if (titre_p !== "") {
            $('#montant_periodique').empty();

            //get montant periodique
            let form = { "periodique_id": titre_p }
            await PeriodiquesService.getTitrePeriodique(form,token).then((response) => {
                console.log(response)

                if (response.data.erreur) {
                    Swal.fire({
                        icon: "error",
                        text: response.data.erreur,
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setValidationError(response.data.erreur)
                } else {
                    //Remplir le select de t_periodique
                    for (let index = 0; index < response.data.montant_publication.length; index++) {
                        const element = response.data.montant_publication[index];

                        $('#montant_periodique').append('<option value="' + element.montant_periodique +
                            '">' + element.montant_periodique + '</option>');

                    }
                }
            }).catch(error => {
                Swal.fire({
                    icon: "error",
                    text: error.message,
                    showConfirmButton: true,
                    timer: 2000
                })
                setValidationError(error.message)
            })
        }

    }

    /////###### GESTION DES MODALS
    const [showCategorie, setShowCategorie] = useState(false);
    const [categorie_libelle, setCategorieLibelle] = useState('')
    const [categorie_description, setCategorieDescription] = useState('')

    const handleCloseCategorie = () => setShowCategorie(false);
    const handleShowCategorie = () => setShowCategorie(true);

    ///Ajouter une categorie via le modal
    const addCategorie = async () => {
        let form = {
            libelle: categorie_libelle, description: categorie_description
        }

        await CategoriesService.store(form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                })
                //setValidationError(response.data.erreur)
            } else {
                handleCloseCategorie()
                fetchCategories();
                //Clear input value on modal
                //$(".modal-input").empty("")
                setCategorieLibelle("")
                setCategorieDescription("")

                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    const [showCollection, setShowCollection] = useState(false);
    const [collection_libelle, setCollectionLibelle] = useState('')
    const [collection_description, setCollectionDescription] = useState('')

    const handleCloseCollection = () => setShowCollection(false);
    const handleShowCollection = () => setShowCollection(true);
    ///Ajouter une Collection via le modal
    const addCollection = async () => {
        let form = {
            libelle: collection_libelle, description: collection_description
        }

        await CollectionsService.store(form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                })
                //setValidationError(response.data.erreur)
            } else {
                handleCloseCollection()
                fetchCollections();
                //Clear input value on modal
                //$(".modal-input").empty("")
                setCollectionLibelle("")
                setCollectionDescription("")

                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    const [showMotcle, setShowMotcle] = useState(false);
    const [motcle_libelle, setMotcleLibelle] = useState('')
    const [motcle_description, setMotcleDescription] = useState('')

    const handleCloseMotcle = () => setShowMotcle(false);
    const handleShowMotcle = () => setShowMotcle(true);
    ///Ajouter un mot cle via le modal
    const addMotcle = async () => {
        let form = {
            libelle: motcle_libelle, description: motcle_description
        }

        await MotsClesService.store(form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                })
                //setValidationError(response.data.erreur)
            } else {
                handleCloseMotcle()
                fetchMotsCles();
                //Clear input value on modal
                //$(".modal-input").empty("")
                setMotcleLibelle("")
                setMotcleDescription("")

                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    const [showEditeur, setShowEditeur] = useState(false);
    const [raison_sociale, setRaisonSociale] = useState('')
    const [telephone, setTelephone] = useState('')
    const [email, setEmail] = useState('')

    const handleCloseEditeur = () => setShowEditeur(false);
    const handleShowEditeur = () => setShowEditeur(true);
    ///Ajouter un editeur via le modal
    const addEditeur = async () => {
        let form = {
            telephone, email, raison_sociale
        }

        await EditeursService.store(form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                })
                //setValidationError(response.data.erreur)
            } else {
                handleCloseEditeur()
                fetchEditeurs();
                //Clear input value on modal
                setRaisonSociale("")
                setTelephone("")
                setEmail("")

                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    const [showAuteur, setShowAuteur] = useState(false);
    const [nom_auteur, setNom] = useState('')
    const [presentation, setPresentation] = useState('')
    const [nom_interlocuteur, setNomInterlocuteur] = useState('')
    const [prenoms_interlocuteur, setPrenomsInterlocuteur] = useState('')
    const [qualite, setQualite] = useState('')
    //const [telephone, setTelephone] = useState('')

    const handleCloseAuteur = () => setShowAuteur(false);
    const handleShowAuteur = () => setShowAuteur(true);
    ///Ajouter un Auteur via le modal
    const addAuteur = async () => {
        let form = {
            nom_auteur, presentation, nom_interlocuteur, telephone, prenoms_interlocuteur, qualite
        }

        await AuteursService.store(form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                })
                //setValidationError(response.data.erreur)
            } else {
                handleCloseAuteur()
                fetchAuteurs();
                //Clear input value on modal
                setNom("")
                setPresentation("")
                setNomInterlocuteur("")
                setPrenomsInterlocuteur("")
                setQualite("")
                setTelephone("")

                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    useEffect(() => {
        fetchTypes();
        fetchEditeurs()
        fetchAuteurs()
        fetchCategories()
        fetchCollections()
        fetchMotsCles()
        $("#submenu-1").addClass("show")
    }, [])

    //##########################/// END METHODES ##########################///

    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.publications_index} >Publications</Link></li>
                                        <li className="breadcrumb-item active">Nouvelle Publication </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Enregistrement </h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-3">
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>
                            <Form encType="multipart/form-data" className="mx-3 settings-form" style={{ textAlign: "left" }} onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Type <i className="text-danger">*</i></Form.Label>
                                            <Form.Select className=" border border-info border" id="type_publication_id" value={typepublication_id} onChange={typeChange} required >
                                                <option value="" selected >-- Sélectionnez une valeur --</option>
                                                {typespublications.length > 0 && typespublications.map(item => (
                                                    <option key={item.id} value={item.id}>{item.libelle}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Editeur <i className="text-danger" id="editeurs_rq">*</i> &nbsp;
                                                <i className="fas fa-plus-circle" onClick={handleShowEditeur}></i></Form.Label>
                                            <Form.Select className=" border border-info border" id="editeurs_id" value={editeur_id} onChange={editeurChange} required>
                                                <option value="" selected>-- Sélectionnez une valeur --</option>
                                                {liste_editeurs.map(item => (
                                                    <option key={item.id} value={item.id}>{item.raison_sociale}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {/* Modal editeur */}
                                    <Modal show={showEditeur} onHide={handleCloseEditeur} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Ajouter une Editeur</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Raison sociale <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setRaisonSociale(e.target.value)}
                                                            value={raison_sociale}
                                                            placeholder=""
                                                            name="raison_sociale"
                                                            aria-label="raison_sociale"
                                                            maxLength={100}
                                                            minLength={3}
                                                            type="text"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>

                                            </Row>
                                            <Row>

                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Téléphone <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setTelephone(e.target.value)}
                                                            value={telephone}
                                                            placeholder=""
                                                            name="telephone"
                                                            aria-label="telephone"
                                                            max={15}
                                                            min={8}
                                                            type="number"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Email <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setEmail(e.target.value)}
                                                            value={email}
                                                            placeholder=""
                                                            name="email"
                                                            aria-label="email"
                                                            maxLength={100}
                                                            minLength={5}
                                                            type="email"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Form.Group className="text-center py-3">
                                                <Button variant="primary" onClick={() => addEditeur()}>
                                                    Enregistrer
                                                </Button>
                                                <Button variant="dark" onClick={handleCloseEditeur} className="mx-4">
                                                    Fermer
                                                </Button>
                                            </Form.Group>
                                        </Modal.Body>
                                    </Modal>
                                    {/* End Modal editeur */}

                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Auteur <i className="text-danger" id="auteur_rq">*</i> &nbsp;
                                                <i className="fas fa-plus-circle" onClick={handleShowAuteur}></i></Form.Label>
                                            <Form.Select className=" border border-info border" id="id_auteur" value={auteur_id} onChange={(e) => setAuteur(e.target.value)} required>
                                                <option value="" selected>-- Sélectionnez une valeur --</option>
                                                {liste_auteurs.map(item => (
                                                    <option key={item.id} value={item.id}>{item.nom_auteur}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {/* Modal auteur */}
                                    <Modal show={showAuteur} onHide={handleCloseAuteur} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Ajout</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nom et prénom (auteur)<i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setNom(e.target.value)}
                                                            value={nom_auteur}
                                                            placeholder="Le nom de l'auteur"
                                                            name="nom_auteur"
                                                            aria-label="nom_auteur"
                                                            maxLength={100}
                                                            minLength={3}
                                                            type="text"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nom interlocuteur <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setNomInterlocuteur(e.target.value)}
                                                            value={nom_interlocuteur}
                                                            placeholder="Le nom de l'interlocuteur"
                                                            name="nom_interlocuteur"
                                                            aria-label="nom_interlocuteur"
                                                            maxLength={100}
                                                            minLength={3}
                                                            type="text"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Prénoms interlocuteur <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setPrenomsInterlocuteur(e.target.value)}
                                                            value={prenoms_interlocuteur}
                                                            placeholder="Le prénom de l'interlocuteur"
                                                            name="prenoms_interlocuteur"
                                                            aria-label="prenoms_interlocuteur"
                                                            maxLength={100}
                                                            minLength={5}
                                                            type="prenoms_interlocuteur"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Téléphone <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setTelephone(e.target.value)}
                                                            value={telephone}
                                                            placeholder="61000001"
                                                            name="telephone"
                                                            aria-label="telephone"
                                                            maxLength={15}
                                                            minLength={8}
                                                            type="number"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Qualite <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setQualite(e.target.value)}
                                                            value={qualite}
                                                            placeholder=""
                                                            name="qualite"
                                                            aria-label="qualite"
                                                            maxLength={100}
                                                            type="text"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>

                                            </Row>
                                            <Row>
                                                <Col md={12} sm={12} className="form-group" >
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Présentation <i className="text-danger">*</i></Form.Label>
                                                        <textarea class="form-control" name="presentation" value={presentation} id="" rows="3" onChange={(e) => setPresentation(e.target.value)}></textarea>
                                                    </Form.Group>
                                                </Col>

                                            </Row>

                                            <Form.Group className="text-center py-3">
                                                <Button variant="primary" onClick={() => addAuteur()}>
                                                    Enregistrer
                                                </Button>
                                                <Button variant="dark" onClick={handleCloseAuteur} className="mx-4">
                                                    Fermer
                                                </Button>
                                            </Form.Group>
                                        </Modal.Body>
                                    </Modal>
                                    {/* End Modal auteur */}
                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Autres auteur(s) <i className="text-danger">*</i> &nbsp;
                                                <i className="fas fa-plus-circle" onClick={handleShowAuteur}></i>
                                            </Form.Label>
                                            <Select id="autre_auteur"
                                                options={auteursOptions}
                                                isMulti
                                                onChange={handleAutreAuteurSelection}
                                                value={autre_auteur_id}
                                                components={animatedComponents}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6} sm={12} className="form-group visually-hidden" id="show_titre_ouvrage">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre Ouvrage<i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setTitreOuvrage(e.target.value)}
                                                value={titre_ouvrage}
                                                placeholder="Titre de l'ouvrage"
                                                name="titre_ouvrage"
                                                aria-label="titre_ouvrage"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                id="titre_ouvrage"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group visually-hidden" id="show_titre_periodique">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre de la périodique <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Select className=" border border-info border" id="t_periodique" onChange={TperiodiqueChange} value={t_periodique}>
                                                <option value="" selected></option>

                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_titre_periodique">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre complémentaire<i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setTitrePeriodique(e.target.value)}
                                                value={titre_periodique}
                                                placeholder="Titre complémentaire"
                                                name="Titre complémentaire"
                                                aria-label="Titre complémentaire"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                id="titre_periodique"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_titre">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Sous-titre <i className="text-danger"></i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setSousTitre(e.target.value)}
                                                value={sous_titre}
                                                placeholder="Sous titre"
                                                name="sous_titre"
                                                aria-label="sous_titre"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                id="sous_titre"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Préfacier <i className="text-danger">*</i> &nbsp;
                                                <i className="fas fa-plus-circle" onClick={handleShowAuteur}></i></Form.Label>
                                            <Form.Select className=" border border-info border" id="prefacier" value={prefacier} onChange={(e) => setPrefacier(e.target.value)}>
                                                <option value="" selected>-- Sélectionnez une valeur --</option>
                                                {liste_auteurs.map(item => (
                                                    <option key={item.id} value={item.id}>{item.nom_auteur}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Avant-propos <i className="text-danger">*</i> &nbsp;
                                                <i className="fas fa-plus-circle" onClick={handleShowAuteur}></i></Form.Label>
                                            <Form.Select className=" border border-info border" id="avant_propos" value={avant_propos} onChange={(e) => setAvantPropos(e.target.value)}>
                                                <option value="" selected>-- Sélectionnez une valeur --</option>
                                                {liste_auteurs.map(item => (
                                                    <option key={item.id} value={item.id}>{item.nom_auteur}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Catégorie(s) <i className="text-danger">*</i> &nbsp;
                                                <i className="fas fa-plus-circle" onClick={handleShowCategorie}></i></Form.Label>

                                            <Select id="categories"
                                                options={categoriesOptions}
                                                isMulti
                                                onChange={handleCategorieSelection}
                                                value={categorie_id}
                                                components={animatedComponents}
                                            />
                                        </Form.Group>
                                    </Col>

                                    {/* Modal categorie */}
                                    <Modal show={showCategorie} onHide={handleCloseCategorie} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Ajouter une categorie</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Libelle <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setCategorieLibelle(e.target.value)}
                                                            value={categorie_libelle}
                                                            placeholder="Libelle"
                                                            name="libelle"
                                                            aria-label="libelle"
                                                            maxLength={100}
                                                            minLength={3}
                                                            type="text"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Description  <i className="text-danger"></i>
                                                        </Form.Label>
                                                        <textarea value={categorie_description} name="resume" id="" cols="30" onChange={(e) => setCategorieDescription(e.target.value)} rows="5" className="form-control summernote border border-info border rounded-2" placeholder=""></textarea>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Form.Group className="text-center py-3">
                                                <Button variant="primary" onClick={() => addCategorie()}>
                                                    Enregistrer
                                                </Button>
                                                <Button variant="dark" onClick={handleCloseCategorie} className="mx-4">
                                                    Fermer
                                                </Button>
                                            </Form.Group>
                                        </Modal.Body>
                                    </Modal>
                                    {/* End Modal categorie */}

                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mots-clés <i className="text-danger">*</i> &nbsp;
                                                <i className="fas fa-plus-circle" onClick={handleShowMotcle}></i>
                                            </Form.Label>
                                            <Select id="tags"
                                                options={motsclesOptions}
                                                isMulti
                                                onChange={handleMotCleSelection}
                                                value={mot_cle}
                                                components={animatedComponents}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {/* Modal mot cle */}
                                    <Modal show={showMotcle} onHide={handleCloseMotcle} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Ajouter un mot cle</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Libelle <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setMotcleLibelle(e.target.value)}
                                                            value={motcle_libelle}
                                                            placeholder="Libelle"
                                                            name="libelle"
                                                            aria-label="libelle"
                                                            maxLength={100}
                                                            minLength={3}
                                                            type="text"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Description  <i className="text-danger"></i>
                                                        </Form.Label>
                                                        <textarea value={motcle_description} name="resume" id="" cols="30" onChange={(e) => setMotcleDescription(e.target.value)} rows="5" className="form-control summernote border border-info border rounded-2" placeholder=""></textarea>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Form.Group className="text-center py-3">
                                                <Button variant="primary" onClick={() => addMotcle()}>
                                                    Enregistrer
                                                </Button>
                                                <Button variant="dark" onClick={handleCloseMotcle} className="mx-4">
                                                    Fermer
                                                </Button>
                                            </Form.Group>
                                        </Modal.Body>
                                    </Modal>
                                    {/* End Modal mot cle */}

                                    <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_montant">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Montant <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setMontantOuvrage(e.target.value)}
                                                value={montant_publication_ouvrage}
                                                placeholder="Prix de l'ouvrage"
                                                name="montant_publication_ouvrage"
                                                aria-label="montant_publication_ouvrage"
                                                maxLength={255}
                                                minLength={3}
                                                type="number"
                                                id="montant_publication"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_montant_periodique">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Montant périodique<i className="text-danger"></i></Form.Label>
                                            <Form.Select className=" border border-info border" id="montant_periodique" onChange={(e) => setMontantPeriodique(e.target.value)} disabled value={montant_publication_periodique}>
                                                <option value="" selected ></option>

                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_collection">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Collection <i className="text-danger">*</i>&nbsp;
                                                <i className="fas fa-plus-circle" onClick={handleShowCollection}></i>
                                            </Form.Label>
                                            <Form.Select className=" border border-info border" id="collection" onChange={(e) => setCollection(e.target.value)} value={collection_id}>
                                                <option value="" selected disabled>-- Sélectionnez une valeur --</option>
                                                {liste_collections.map(item => (
                                                    <option key={item.id} value={item.id}>{item.libelle}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {/* Modal collection */}
                                    <Modal show={showCollection} onHide={handleCloseCollection} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Ajouter une collection</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Libelle <i className="text-danger">*</i>
                                                        </Form.Label>
                                                        <Form.Control className="border border-info border rounded-2" onChange={(e) => setCollectionLibelle(e.target.value)}
                                                            value={collection_libelle}
                                                            placeholder="Libelle"
                                                            name="libelle"
                                                            aria-label="libelle"
                                                            maxLength={100}
                                                            minLength={3}
                                                            type="text"
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col md={12} sm={12} className="form-group">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Description  <i className="text-danger"></i>
                                                        </Form.Label>
                                                        <textarea value={collection_description} name="resume" id="" cols="30" onChange={(e) => setCollectionDescription(e.target.value)} rows="5" className="form-control summernote border border-info border rounded-2" placeholder=""></textarea>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Form.Group className="text-center py-3">
                                                <Button variant="primary" onClick={() => addCollection()}>
                                                    Enregistrer
                                                </Button>
                                                <Button variant="dark" onClick={handleCloseCollection} className="mx-4">
                                                    Fermer
                                                </Button>
                                            </Form.Group>
                                        </Modal.Body>
                                    </Modal>
                                    {/* End Modal categorie */}

                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Date de publication <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setAnneePublication(e.target.value)}
                                                value={annee_publication}
                                                name="annee_publication"
                                                aria-label="annee_publication"
                                                minLength={4}
                                                maxLength={4}
                                                min={1900}
                                                max={(new Date().getFullYear())}
                                                required
                                                type="number"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Code ISBN  <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setCodeIsbn(e.target.value)}
                                                value={code_isbn}
                                                name="code_isbn"
                                                aria-label="code_isbn"
                                                minLength={3}
                                                required
                                                type="number"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nombre de page  <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setNbrePage(e.target.value)}
                                                value={nbre_page}
                                                name="nbre_page"
                                                aria-label="nbre_page"
                                                minLength={0}
                                                required
                                                type="number"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>PDF Disponible ?  <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Select className=" border border-info border" onChange={choixPdf} value={choix_pdf} id="choix_pdf">
                                                <option value="" selected>-- Sélectionnez une valeur --</option>
                                                <option value="1">Oui</option>
                                                <option value="0">Non</option>

                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Couverture  <i className="text-danger">*</i> &nbsp; (JPEG - PNG - JPG)
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setLaUne(e.target.files[0])}
                                                name="laune"
                                                aria-label="laune"
                                                required
                                                type="file"
                                                id="laune"
                                                accept="image/jpeg, image/jpg, image/png, image/PNG, image/JPG, image/JPEG"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group visually-hidden" id="show_publication">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Publication  <i className="text-danger">*</i> &nbsp; (PDF)
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setPublication(e.target.files[0])}
                                                name="publication"
                                                aria-label="publication"
                                                required
                                                type="file"
                                                accept="document/pdf"
                                                id="publication"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Résumé / Sommaire  <i className="text-danger">*</i> &nbsp; (PDF)
                                            </Form.Label>
                                            <textarea required value={resume} name="resume" id="" cols="30" onChange={(e) => setResume(e.target.value)} rows="5" className="form-control summernote border border-info border rounded-2" placeholder=""></textarea>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Button type="submit" variant="primary">Enregistrer</Button>
                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}